const NS = 'VideoModalBlock';
const CLS = 'videoModalBlock';

import { utils } from '../../../../global/js/utils';

export class VideoModalBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$modal = this.$element.find(`.modal`);
		this.$iframe = this.$modal.find('.videoBlock-iframe');
		this.$videoContainer = this.$element.find(`.${CLS}-videoContainer`);

		this.videoType = this.$element.data('videoType');
		this.videoSrcId = this.$element.data('videoSrcId');
		this.videoLocalSrc = this.$element.data('videoLocalSrc');

		this.$modal.addClass('modal--black');
		this.initVideo();
	}

	initVideo() {
		this.$videoContainer.on('click', () => {
			
			// Embed
			if(this.videoSrcId) {
				if (this.$iframe.length === 0) return;
				let embedLink = '';

				switch (this.videoType) {
					case utils.VID_TYPE.youku:
						embedLink = `https://player.youku.com/embed/${this.videoSrcId}?autoplay=0&rel=0`;
						break;

					default:
						// set default as youtube
						embedLink = `https://www.youtube.com/embed/${this.videoSrcId}?autoplay=0&showinfo=0&controls=0&rel=0`;
						break;
				}

				this.$modal.modal('show');
				$('.modal-backdrop').addClass('modal-backdrop--black');
				this.$iframe.attr('src', embedLink);
			}
			// Local file
			else if(this.videoLocalSrc) {
				this.$modal.modal('show');
				let $video = this.$modal.find('video');
				$('.modal-backdrop').addClass('modal-backdrop--black');

				$video[0].play();
			}
			else {
				console.error(`${NS}::Error`, 'Please supply a video-src-id or a video-local-src value to load a video on the modal.');
			}
		});

		this.$modal.on('hidden.bs.modal', () => {
			// Embed
			if(this.videoSrcId) {
				this.$iframe.removeAttr('src');
			}
			// Local File
			else if(this.videoLocalSrc) {
				let $video = this.$modal.find('video');
				$video[0].pause();
				$video[0].currentTime = 0;
			}
		});
	}
}
